export const BASE_URL = import.meta.env.VITE_API_URL;
export const TEST_URL = import.meta.env.VITE_TEST_API_URL;
export const DEFAULT_TIMEOUT = 2000;
export const DEFAULT_HEADERS = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
};
